import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import * as _ from 'lodash';
import { IUser, IUserChangePwd } from '../../../users-page/users/users.interface';
import { AuthService } from '../../../../shared/services/auth.service';
import { UserService } from '../../../users-page/users/users.service';
import { AlertService } from '../../../../shared/services/alert.service';
import { matchingPasswords, passwordValidator } from '../../../../shared/util/app-validators';

let self: any;

@Component({
  selector: 'app-password-modal',
  templateUrl: './password-modal.component.html',
  styleUrls: ['./password-modal.component.css']
})
export class PasswordModalComponent implements OnInit {
  @ViewChild('oldPasswordInput') oldPasswordInput!: ElementRef;
  @ViewChild('newPasswordInput') newPasswordInput!: ElementRef;
  @ViewChild('repeatPasswordInput') repeatPasswordInput!: ElementRef;
  viewOldPassword = false;
  viewNewPassword = false;
  viewRepeatPassword = false;

  resetPassword = false;  // if is open by admin
  user!: IUser;

  dialog: MatDialogRef<any>;
  readOnly: boolean = false;
  loading: boolean = false;
  credentials!: IUserChangePwd;
  form!: UntypedFormGroup;
  submitted = false;
  isDev!: boolean;

  constructor(
    public dialogRef: MatDialogRef<any>,
    private fb: UntypedFormBuilder,
    private _AuthService: AuthService,
    private _UserService: UserService,
    private alertService: AlertService,
  ) {
    self = this;
    this.dialog = dialogRef;
  }

  ngOnInit(): void {
    this.buildForm();
  }

  get f() { return this.form.controls; }
  buildForm() {
    this.form = this.fb.group({
      oldPassword: this.resetPassword ? [] : ['', Validators.compose([Validators.required, Validators.minLength(6)])],
      newPassword: ['', Validators.compose([Validators.required, Validators.minLength(6), passwordValidator])],
      repeatPassword: ['', [Validators.required]],
    }, { validator: matchingPasswords('newPassword', 'repeatPassword') });
  }

  toggleOldPasswordView() {
    this.viewOldPassword = !this.viewOldPassword;
    this.oldPasswordInput.nativeElement.type = this.viewOldPassword ? 'text' : 'password';
  }

  toggleNewPasswordView() {
    this.viewNewPassword = !this.viewNewPassword;
    this.newPasswordInput.nativeElement.type = this.viewNewPassword ? 'text' : 'password';
  }

  toggleRepeatPasswordView() {
    this.viewRepeatPassword = !this.viewRepeatPassword;
    this.repeatPasswordInput.nativeElement.type = this.viewRepeatPassword ? 'text' : 'password';
  }

  onSubmit() {
    this.submitted = true;
    let data: IUserChangePwd = _.cloneDeep(this.form.value);
    if (this.form.invalid) return;
    let user = this._AuthService.profile();
    if (!this.resetPassword) {
      this._UserService.changeUserPassword(user.id, data).subscribe((result) => {
        this.alertService.alert('Cambio de contraseña exitoso');
        this.dialog.close(result);
      });
    }
    else {
      delete data.oldPassword;
      this._UserService.resetUserPassword(this.user._id || '', data).subscribe((result) => {
        this.alertService.alert('Cambio de contraseña exitoso');
        this.dialog.close(result);
      });
    }
  }
}